import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdditionalRequiredSolutionsButtonComponent} from './additional-required-solutions-button.component';
import {I18nModule} from '@spartacus/core';
import {ModalModule, TooltipModule} from 'ng-design-system';
import {
  AdditionalRequiredSolutionsModalComponent
} from './additional-required-solutions-modal/additional-required-solutions-modal.component';
import {
  AdditionalRequiredSolutionComponent
} from './additional-required-solution/additional-required-solution.component';
import {IconButtonTooltipModule} from '@dcp/configurator';


@NgModule({
  declarations: [
    AdditionalRequiredSolutionsButtonComponent,
    AdditionalRequiredSolutionsModalComponent,
    AdditionalRequiredSolutionComponent,
  ],
  exports: [
    AdditionalRequiredSolutionsButtonComponent,
    AdditionalRequiredSolutionsModalComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    ModalModule,
    TooltipModule,
    IconButtonTooltipModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class AdditionalRequiredSolutionsButtonModule {
}
